import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id B4F0331A-3E21-40C4-AED4-A28FD929AD21
 * name send-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/send-outline.svg
 * tags
 */
export const SendOutlineIcon = createSvgIcon(<><path d="M4 6.03L11.5 9.25L4 8.25L4 6.03M11.5 14.75L4 17.97V15.75L11.5 14.75M2 3L2 10L17 12L2 14L2 21L23 12L2 3Z" /></>, 'SendOutlineIcon');
export default SendOutlineIcon